// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2jS2_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1cyIP","obliqueLine":"membershipbadge_obliqueLine__1fXQS"};